<template>
    <div class="tsa-subTitle">
        <p><slot></slot></p>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
    @import './css/mobile.scss';
</style>